import { all } from 'redux-saga/effects';
import profileSaga from 'modules/Profile/saga';
import addCandidateSagas from 'modules/Candidates/saga';
import shareLinkByEmailSagas from 'components/Modal/ShareLinkModal/saga';
import editCandidatesNotesSaga from 'components/Modal/EditCandidatesNotes/saga';
import attachFileSagas from 'components/Modal/AttachFile/saga';
import jobBoardSagas from 'modules/JobBoard/saga';
import adminSaga from 'modules/Admin/saga';
import searchByLocationSagas from 'components/Modal/SearchByLocation/saga';
import sendMessagesSagas from 'components/Modal/SendMessages/saga';
import logOutSaga from './logOut';
import forgotPasswordSaga from '../modules/ForgotPassword/saga';
import signUpSaga from '../modules/SignUp/saga';
import signInSaga from '../modules/SignIn/saga';
import resetPasswordSaga from '../modules/ResetPassword/sagas';
import createJobPostSagas from '../modules/JobPosts/saga';
import dashBoardSagas from '../modules/DashBoard/saga';

export default function* rootSaga() {
  yield all([
    signUpSaga(),
    signInSaga(),
    forgotPasswordSaga(),
    resetPasswordSaga(),
    profileSaga(),
    createJobPostSagas(),
    addCandidateSagas(),
    logOutSaga(),
    shareLinkByEmailSagas(),
    attachFileSagas(),
    searchByLocationSagas(),
    sendMessagesSagas(),
    jobBoardSagas(),
    dashBoardSagas(),
    editCandidatesNotesSaga(),
    adminSaga(),
  ]);
}
